import lozad, { Observer } from "lozad";

class LazyLoadService {
  private observer: Observer;

  constructor() {
    this.observer = lozad();
  }

  observe = () => {
    this.observer.observe();
  };
}

// Make sure only one instance of LazyLoadService is created
const lazyLoadService = new LazyLoadService();
Object.freeze(lazyLoadService);

export { lazyLoadService };
